var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ForwardArrow } from '@/icons';
import SidePanel from '@/common/side-panel';
import Header from '@/common/header';
import { Button } from '@/common';
import { useNavigate } from 'react-router-dom';
import { useQuery } from '@/hoc/hooks/useQuery';
import { useMutation } from '@/hoc/hooks/useMutation';
var JobScheduling = function () {
    var _a = useState({
        config: '',
        encryptionType: '',
        scheduleType: '',
        notificationEmail: '',
        frequency: '',
        date: '',
        time: '',
        jobname: '',
    }), formData = _a[0], setFormData = _a[1];
    var _b = useState([]), configOptions = _b[0], setConfigOptions = _b[1];
    var handleChange = function (e) {
        var _a = e.target, name = _a.name, value = _a.value;
        setFormData(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[name] = value, _a)));
        });
    };
    var handleSubmit = function () {
        var erros = validateFormData(formData);
        if (erros.length > 0) {
            //alert(erros.join('\n'));
            toast.error(erros.join('\n'));
            return;
        }
        var dateTime = formData.date && formData.time ? "".concat(formData.date, "T").concat(formData.time) : null;
        // console.log('Form submitted:', { ...formData, dateTime });
        trigger("/cron", 'POST', {
            jobName: formData.jobname,
            jobEncType: 'aes-256-cbc',
            scheduleType: formData.scheduleType,
            // "dateTime": `${new Date().getDate().toString().padStart(2, '0')}-${new Date().toLocaleString('en-US', { month: 'short' })}-${new Date().getFullYear()}`,
            dateTime: dateTime,
            notificationEmail: formData.notificationEmail,
            frequency: formData.frequency,
            configId: formData.config,
        })
            .then(function (res) {
            console.log('Response:', res);
            toast.success('Job created successfully!');
            navigate(-1);
        })
            .catch(function (err) {
            console.error('Error:', err);
            toast.error(err.message || 'Something went wrong');
            // Handle error response
        });
    };
    var encryptionTypes = [{ value: 'aes', label: 'AES-256' }];
    var scheduleTypes = [
        // { value: 'once', label: 'Run Once' },
        { value: 'cron', label: 'cron' },
    ];
    var frequencies = [
        { label: 'Every Minute', value: '* * * * *' },
        { label: 'Every 2 Minutes', value: '*/2 * * * *' },
        { label: 'Every 3 Minutes', value: '*/3 * * * *' },
        { label: 'Every 4 Minutes', value: '*/4 * * * *' },
        { label: 'Every 5 Minutes', value: '*/5 * * * *' },
        { label: 'Every 6 Minutes', value: '*/6 * * * *' },
        { label: 'Every 10 Minutes', value: '*/10 * * * *' },
        { label: 'Every 12 Minutes', value: '*/12 * * * *' },
        { label: 'Every 15 Minutes', value: '*/15 * * * *' },
        { label: 'Every 20 Minutes', value: '*/20 * * * *' },
        { label: 'Every 30 Minutes', value: '*/30 * * * *' },
        { label: 'Hourly', value: '0 * * * *' },
        { label: 'Every 2 Hours', value: '0 */2 * * *' },
        { label: 'Every 3 Hours', value: '0 */3 * * *' },
        { label: 'Every 4 Hours', value: '0 */4 * * *' },
        { label: 'Every 6 Hours', value: '0 */6 * * *' },
        { label: 'Every 8 Hours', value: '0 */8 * * *' },
        { label: 'Every 12 Hours', value: '0 */12 * * *' },
        { label: 'Daily at Midnight', value: '0 0 * * *' },
        { label: 'Daily at 1 AM', value: '0 1 * * *' },
        { label: 'Daily at 2 AM', value: '0 2 * * *' },
        { label: 'Daily at 3 AM', value: '0 3 * * *' },
        { label: 'Daily at 4 AM', value: '0 4 * * *' },
        { label: 'Daily at 5 AM', value: '0 5 * * *' },
        { label: 'Daily at 6 AM', value: '0 6 * * *' },
        { label: 'Daily at 7 AM', value: '0 7 * * *' },
        { label: 'Daily at 8 AM', value: '0 8 * * *' },
        { label: 'Daily at 9 AM', value: '0 9 * * *' },
        { label: 'Daily at 10 AM', value: '0 10 * * *' },
        { label: 'Daily at 11 AM', value: '0 11 * * *' },
        { label: 'Daily at Noon', value: '0 12 * * *' },
        { label: 'Daily at 1 PM', value: '0 13 * * *' },
        { label: 'Daily at 2 PM', value: '0 14 * * *' },
        { label: 'Daily at 3 PM', value: '0 15 * * *' },
        { label: 'Daily at 4 PM', value: '0 16 * * *' },
        { label: 'Daily at 5 PM', value: '0 17 * * *' },
        { label: 'Daily at 6 PM', value: '0 18 * * *' },
        { label: 'Daily at 7 PM', value: '0 19 * * *' },
        { label: 'Daily at 8 PM', value: '0 20 * * *' },
        { label: 'Daily at 9 PM', value: '0 21 * * *' },
        { label: 'Daily at 10 PM', value: '0 22 * * *' },
        { label: 'Daily at 11 PM', value: '0 23 * * *' },
        { label: 'Weekly on Sunday at Midnight', value: '0 0 * * 0' },
        { label: 'Weekly on Monday at Midnight', value: '0 0 * * 1' },
        { label: 'Weekly on Tuesday at Midnight', value: '0 0 * * 2' },
        { label: 'Weekly on Wednesday at Midnight', value: '0 0 * * 3' },
        { label: 'Weekly on Thursday at Midnight', value: '0 0 * * 4' },
        { label: 'Weekly on Friday at Midnight', value: '0 0 * * 5' },
        { label: 'Weekly on Saturday at Midnight', value: '0 0 * * 6' },
        { label: 'Monthly on 1st at Midnight', value: '0 0 1 * *' },
        { label: 'Monthly on 15th at Midnight', value: '0 0 15 * *' },
        { label: 'Monthly on Last Day at Midnight', value: '0 0 L * *' },
        { label: 'Every Weekday at 8 AM', value: '0 8 * * 1-5' },
        { label: 'Every Weekend at 10 AM', value: '0 10 * * 6,0' },
        { label: 'Every Monday and Friday at 9 AM', value: '0 9 * * 1,5' },
        { label: 'Every Tuesday and Thursday at 4 PM', value: '0 16 * * 2,4' },
        { label: 'Every 5 Minutes Weekdays Only', value: '*/5 * * * 1-5' },
        { label: 'Every Hour on Weekends Only', value: '0 * * * 6,0' },
        { label: 'Quarterly (Jan, Apr, Jul, Oct) on 1st at Midnight', value: '0 0 1 1,4,7,10 *' },
        { label: 'Biannually (Jan, Jul) on 1st at Midnight', value: '0 0 1 1,7 *' },
        { label: 'Annually on Jan 1st at Midnight', value: '0 0 1 1 *' },
        { label: 'Every 15th and Last Day at 11 PM', value: '0 23 15,L * *' },
        { label: 'Every Monday at 6 AM', value: '0 6 * * 1' },
        { label: 'Every Monday at Noon', value: '0 12 * * 1' },
        { label: 'Every Sunday at 5 PM', value: '0 17 * * 0' },
        { label: 'Every Saturday at 10 PM', value: '0 22 * * 6' },
        { label: 'Every Friday at 3 PM', value: '0 15 * * 5' },
        { label: 'Every 1st and 15th of Month at 6 AM', value: '0 6 1,15 * *' },
        { label: 'Twice a Day: 6 AM and 6 PM', value: '0 6,18 * * *' },
        { label: 'Three Times a Day: 6 AM, 2 PM, 10 PM', value: '0 6,14,22 * * *' },
        { label: 'Every 10 Minutes during Business Hours (9–5)', value: '*/10 9-17 * * *' },
        // Edge & custom cases
        { label: 'First Monday of the Month at 8 AM', value: '0 8 1-7 * 1' },
        { label: 'Every 2nd Tuesday at Noon', value: '0 12 8-14 * 2' },
        { label: 'Every Last Friday of the Month at 5 PM', value: '0 17 * * 5#5' }, // not supported by all engines
        { label: 'Weekdays at 9 AM and 5 PM', value: '0 9,17 * * 1-5' },
        // Generic intervals
        { label: 'Every 45 Minutes', value: '*/45 * * * *' },
        { label: 'Every 90 Minutes', value: '0 */1,*/3 * * *' },
        { label: 'Every 2 Days at Midnight', value: '0 0 */2 * *' },
        { label: 'Every 3 Days at 2 PM', value: '0 14 */3 * *' },
        { label: 'Every 4 Days at 8 AM', value: '0 8 */4 * *' },
        { label: 'Every 6 Days at 6 PM', value: '0 18 */6 * *' },
        // Unusual patterns
        { label: 'Every 29th February at Midnight (leap year)', value: '0 0 29 2 *' },
        { label: 'Every Hour on the 1st Monday of the Month', value: '0 * 1-7 * 1' },
        { label: 'First Day of Month at 6:30 AM', value: '30 6 1 * *' },
        { label: 'Midnight on Sundays and Wednesdays', value: '0 0 * * 0,3' },
        { label: 'Every 15 Minutes on Weekends', value: '*/15 * * * 6,0' },
        { label: 'Every Business Day at 9:15 AM', value: '15 9 * * 1-5' },
    ];
    var _c = useState(true), sidePanelOpen = _c[0], setSidePanelOpen = _c[1];
    var _d = useState(false), isMobile = _d[0], setIsMobile = _d[1];
    var navigate = useNavigate();
    var apiResponse = useQuery('/metadatadbdetails/getconfigdetails').data;
    var _e = useMutation(), trigger = _e.trigger, jobPostData = _e.data, jobPostLoading = _e.loading, jobPostError = _e.error;
    useEffect(function () {
        var checkIfMobile = function () {
            setIsMobile(window.innerWidth < 768);
            // Force close panel if mobile
            if (window.innerWidth < 768) {
                setSidePanelOpen(false);
            }
        };
        // Initial check
        checkIfMobile();
        // Add event listener
        window.addEventListener('resize', checkIfMobile);
        return function () { return window.removeEventListener('resize', checkIfMobile); };
    }, []);
    useEffect(function () {
        if (apiResponse === null || apiResponse === void 0 ? void 0 : apiResponse.data) {
            var options = apiResponse.data.map(function (item) { return ({
                value: item._id,
                label: item.configName,
            }); });
            setConfigOptions(options);
        }
    }, [apiResponse]);
    console.log(formData, 'formData');
    var validateFormData = function (formData) {
        var errors = [];
        if (!formData.jobname) {
            errors.push('Job name is required.');
        }
        if (!formData.config) {
            errors.push('Config ID is required.');
        }
        if (!formData.date) {
            errors.push('Date is required.');
        }
        if (!formData.time) {
            errors.push('Time is required.');
        }
        // If encryption type is configurable, you can add:
        // if (!formData.jobEncType) {
        //   errors.push("Encryption type is required.");
        // }
        return errors;
    };
    return (_jsxs("div", { className: 'flex min-h-screen bg-gray-50', children: [_jsx(SidePanel, { open: sidePanelOpen, onMenuClick: function () { return setSidePanelOpen(function (prev) { return !prev; }); }, isMobile: isMobile }), _jsx("div", { className: "flex-1 transition-all duration-300 ".concat(isMobile ? 'ml-0' : sidePanelOpen ? 'md:ml-0' : 'md:ml-0'), children: _jsxs("div", { className: 'p-2 md:p-2', children: [_jsx(Header, {}), _jsxs("div", { className: 'flex flex-col md:flex-row md:justify-between md:items-center mb-6 gap-4', children: [_jsx("h1", { className: 'text-xl md:text-2xl font-semibold text-gray-800', children: "Job Scheduling" }), _jsxs("div", { className: 'flex flex-col sm:flex-row gap-3 w-full md:w-auto', children: [_jsx(Button, { label: 'Cancel', className: 'px-4 py-2 rounded-lg border border-[#6C63FF] text-blue-800 bg-violet-100 hover:bg-[#e6e1ff] transition font-medium text-md w-full md:w-auto cursor-pointer', onClick: function () { return navigate('/view-all-jobs'); } }), _jsx(Button, { label: 'Save Job', icon: _jsx(ForwardArrow, {}), className: 'flex items-center justify-center bg-blue-700 text-white px-4 py-2 rounded-lg hover:bg-blue-800 text-md font-medium w-full md:w-auto cursor-pointer', onClick: handleSubmit })] })] }), _jsxs("div", { className: 'bg-white p-4 md:p-6 rounded-xl shadow', children: [_jsx("h2", { className: 'text-lg md:text-xl font-semibold text-gray-800 mb-4', children: "Scheduling" }), _jsx("div", { className: 'grid grid-cols-1  gap-4 mb-2', children: _jsxs("div", { className: 'p-3 border border-gray-300 rounded-md bg-gray-100', children: [_jsxs("label", { className: 'block text-sm font-medium text-gray-700 mb-1', children: ["Job Name", _jsx("span", { className: 'text-red-500', children: "*" })] }), _jsx("input", { type: 'text', name: 'jobname', className: 'w-full px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500', placeholder: 'Enter Job Name', value: formData.jobname, onChange: handleChange })] }) }), _jsxs("div", { className: 'grid grid-cols-1 md:grid-cols-2 gap-4', children: [_jsxs("div", { className: 'mb-4 p-3 border border-gray-300 rounded-md bg-gray-100', children: [_jsxs("label", { className: 'block text-sm font-medium text-gray-700 mb-1', children: ["Config", _jsx("span", { className: 'text-red-500', children: "*" })] }), _jsxs("select", { name: 'config', className: 'w-full px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500', value: formData.config, onChange: handleChange, children: [_jsx("option", { value: '', children: "Select Saved Config" }), configOptions.map(function (option) { return (_jsx("option", { value: option.value, children: option.label }, option.value)); })] })] }), _jsxs("div", { className: 'mb-4 p-3 border border-gray-300 rounded-md bg-gray-100', children: [_jsxs("label", { className: 'block text-sm font-medium text-gray-700 mb-2', children: ["Encryption Type ", _jsx("span", { className: 'text-red-500', children: "*" })] }), _jsxs("select", { name: 'encryptionType', className: 'w-full px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500', value: formData.encryptionType, onChange: handleChange, required: true, children: [_jsx("option", { value: '', children: "Select Type" }), encryptionTypes.map(function (option) { return (_jsx("option", { value: option.value, children: option.label }, option.value)); })] })] })] }), _jsxs("div", { className: 'space-y-4', children: [_jsxs("div", { className: 'p-3 border border-gray-300 rounded-md bg-gray-100', children: [_jsxs("label", { className: 'block text-sm font-medium text-gray-700 mb-1', children: ["Date and Time", _jsx("span", { className: 'text-red-500', children: "*" })] }), _jsxs("div", { className: 'flex flex-col sm:flex-row gap-2', children: [_jsx("input", { type: 'date', name: 'date', className: 'w-full px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500', value: formData.date, onChange: handleChange }), _jsx("input", { type: 'time', name: 'time', className: 'w-full px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500', value: formData.time, onChange: handleChange })] })] }), _jsxs("div", { className: 'grid grid-cols-1 md:grid-cols-2 gap-4', children: [_jsxs("div", { className: 'p-3 border border-gray-300 rounded-md bg-gray-100', children: [_jsx("label", { className: 'block text-sm font-medium text-gray-700 mb-1', children: "Schedule Type" }), _jsxs("select", { name: 'scheduleType', className: 'w-full px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500', value: formData.scheduleType, onChange: handleChange, children: [_jsx("option", { value: '', children: "Select Picker" }), scheduleTypes.map(function (option) { return (_jsx("option", { value: option.value, children: option.label }, option.value)); })] })] }), formData.scheduleType !== 'once' && (_jsxs("div", { className: 'p-3 border border-gray-300 rounded-md bg-gray-100', children: [_jsx("label", { className: 'block text-sm font-medium text-gray-700 mb-1', children: "Frequency" }), _jsxs("select", { name: 'frequency', className: 'w-full px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500', value: formData.frequency, onChange: handleChange, children: [_jsx("option", { value: '', children: "Select Frequency" }), frequencies.map(function (option) { return (_jsx("option", { value: option.value, children: option.label }, option.value)); })] })] }))] })] })] })] }) })] }));
};
export default JobScheduling;
